import { render, staticRenderFns } from "./GradePraise.vue?vue&type=template&id=3c2f631a&scoped=true&"
import script from "./GradePraise.vue?vue&type=script&lang=js&"
export * from "./GradePraise.vue?vue&type=script&lang=js&"
import style0 from "./GradePraise.vue?vue&type=style&index=0&id=3c2f631a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f631a",
  null
  
)

export default component.exports